// Which canvas node interactions a viewer may start.
//
// The patient portal shows the family pedigree read-only. Before this, a
// right-click on a person there still opened the clinician context menu (Add
// relative, Migrate person, ...), and a double-click on a pregnancy opened its
// editor, because ChartBox checked only the pedigree lock and selection mode.
// The server refuses those writes for a patient; the affordances must not
// appear in the first place. One place decides, so the two handlers cannot
// drift apart.

/** May this viewer open the node context menu? */
export const canOpenNodeMenu = ({ patient, isLocked, selectionMode }) =>
  !patient && !isLocked && !selectionMode;

/** May this viewer open a pregnancy/fetus record's editor by double-click? */
export const canOpenReproEditor = ({ patient, isLocked }) =>
  !patient && !isLocked;
